import { Heading, Text, Badge, Flex, Link } from '@chakra-ui/react'
import * as React from 'react'
import { ExternalLinkIcon } from '@chakra-ui/icons'

export interface ProjectCardProps {
  name: string
  url: string
  description: string
  skills?: string[]
}

function ProjectCard({ name, url, description, skills }: ProjectCardProps) {
  return (
    <Flex direction="column" as="article" maxW="xs" p="5" borderWidth="1px" rounded="md" h="100%">
      <Heading size="md" my="2">
        <Link color="teal.500" href={url} isExternal>
          {name} <ExternalLinkIcon mx="2px" />
        </Link>
      </Heading>
      <Text flex={1} mb={2}>
        {description}
      </Text>
      <Flex wrap="wrap" w="100%" gap={2}>
        {skills?.map((s) => (
          <Badge alignItems="center" key={s}>
            {s}
          </Badge>
        ))}
      </Flex>
    </Flex>
  )
}

ProjectCard.defaultProps = {
  skills: [],
}

export default ProjectCard
